import {SET_APHORISMS, CREATE_APHORISM, DELETE_APHORISM} from '../constants/aphorisms';

const initialState = {
  count: 0,
  list: []
};

const aphorismsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APHORISMS:
      return {
        ...state,
        count: action.count,
        list: action.list,
      };
    case CREATE_APHORISM:
      return {
        ...state,
        list: [...state.list, action.item],
      };
    case DELETE_APHORISM:
      return {
        ...state,
        list: state.list.filter(o => o.id !== action.id),
      };
    default:
      return state;
  }
};

export default aphorismsReducer;